import PropTypes from 'prop-types'
import React from 'react'
import { FaFacebookF } from 'react-icons/fa'
import { facebookShareUrl } from 'utils'

import { StyledFacebookButton, StyledFbContainer } from './styles'

const FacebookButton = ({ text = '', message = '', tokenId, cardId, appId, hashtag = '', fbsInfos }) => {
  const url = facebookShareUrl(appId, tokenId, cardId, fbsInfos)
  const link = `https://www.facebook.com/dialog/share?app_id=2421154144601784&display=popup&hashtag=${encodeURIComponent(
    hashtag
  )}&href=${encodeURIComponent(url)}${message && `&quote=${encodeURIComponent(message)}`}&sdk=joey`

  return (
    <StyledFbContainer>
      <StyledFacebookButton id="facebook button" data-ga="link facebook share" href={link} target="_blank">
        <i>
          <FaFacebookF />
        </i>
        <label>{text}</label>
      </StyledFacebookButton>
    </StyledFbContainer>
  )
}

FacebookButton.propTypes = {
  appId: PropTypes.string,
  cardId: PropTypes.any,
  hashtag: PropTypes.string,
  message: PropTypes.string,
  text: PropTypes.string,
  tokenId: PropTypes.any,
}

export default FacebookButton
